import { ChangeEvent, MouseEvent, useCallback, useRef, useState } from 'react'
import _ from 'lodash'
import { L1ReasonableButton } from '../l1/L1Button'
import { faCamera, faTrash } from '@fortawesome/pro-regular-svg-icons'
import L2ControlGrid from '../l2/L2ControlGrid'
import L2ControlGridLayout from '../l2/L2ControlGridLayout'
import L2Surface from '../l2/L2Surface'
import { FusionColor } from '../../../theme/FusionStyle'
import { ConceptStatus } from '@fusion-advantage/backcompat'
import { L3Image, L3ImageFormat } from './L3Image'
import Loading from '../../Loading'
import L3ImageDialog from './L3ImageDialog'
import { L4NoPrint } from '../l4/L4Print'

interface L3DocumentCameraProps {
	conceptStatus: ConceptStatus | null,
	onFileChange: (e: ChangeEvent<HTMLInputElement>) => void
	onDelete: (e: MouseEvent<HTMLButtonElement>) => void
	loading: Boolean
}

export const L3DocumentCamera = ({ conceptStatus, onFileChange, onDelete, loading }: L3DocumentCameraProps) => {
	const fileInputRef = useRef<HTMLInputElement>(null)
	const [isModalOpen, setIsModalOpen] = useState(false)

	const hasImage = conceptStatus && conceptStatus.value !== null

	const handleButtonClick = useCallback(() => {
		fileInputRef.current?.click()
	}, [fileInputRef])

	const handleViewClick = useCallback(() => {
		setIsModalOpen(true)
	}, [setIsModalOpen])

	const handleCloseModal = useCallback(() => {
	setIsModalOpen(false)
	}, [setIsModalOpen])

	return (
		<>
			<L3ImageDialog
				format={L3ImageFormat.DownloadFile}
				show={isModalOpen}
				conceptStatus={conceptStatus}
				onClose={handleCloseModal}
			/>
			{/* claude says: should submit jpeg on iOS */}
			<input
				ref={fileInputRef}
				type="file"
				accept="image/*"
				style={{ display: 'none' }}
				onChange={onFileChange}
			/>
			{
				hasImage ?
					<L2Surface>
						<L2ControlGrid layout={L2ControlGridLayout.FlexRow} columnCount={2}>
							<L3Image
								format={L3ImageFormat.DownloadFile}
								thumbnail={true}
								conceptStatus={conceptStatus}
								onClick={handleViewClick}
							/>
							<L1ReasonableButton
								label="Delete"
								icon={faTrash}
								color={FusionColor.StopRed}
								onClick={onDelete}
							/>
						</L2ControlGrid>
					</L2Surface> :
					loading ? <Loading /> : <L4NoPrint><L1ReasonableButton label="Add" icon={faCamera} onClick={handleButtonClick} /></L4NoPrint>
			}
		</>
	)
}

export default L3DocumentCamera